// Audit Logs translations for React Admin resource
export const auditLogsResource = {
  name: '稽核日誌',
  fields: {
    id: 'ID',
    createdAt: '時間',
    action: '操作',
    user: '使用者',
    userId: '使用者 ID',
    resource: '資源',
    resourceType: '資源',
    resourceId: '資源 ID',
    details: '詳細資訊',
    additionalInfo: '附加資訊',
    fullDetails: '完整詳情',
    ipAddress: 'IP 位址',
    userAgent: '使用者代理',
    startDate: '開始日期',
    endDate: '結束日期',
  },
};

// Custom audit logs translations for components
export const auditLogs = {
  list: {
    title: '稽核日誌',
    filters: {
      search: '搜尋',
      action: '操作',
      userId: '使用者 ID',
      startDate: '開始日期',
      endDate: '結束日期',
    },
  },
  actions: {
    'auth.login': '登入',
    'auth.login.failed': '登入失敗',
    'auth.logout': '登出',
    'auth.2fa.enable': '啟用雙重驗證',
    'auth.2fa.disable': '停用雙重驗證',
    'auth.2fa.admin.disable': '管理員停用使用者雙重驗證',
    'user.create': '建立使用者',
    'user.update': '更新使用者',
    'user.delete': '刪除使用者',
    'user.preferences.update': '更新偏好設定',
    'role.create': '建立角色',
    'role.update': '更新角色',
    'role.delete': '刪除角色',
    'permission.assign': '指派權限',
    'settings.update': '更新設定',
    'settings.logo.upload': '上傳標誌',
    'settings.logo.delete': '刪除標誌',
    'update_app_user': '更新應用程式用戶',
    'logout': '登出',
    'login': '登入',
    // Legacy format (with colons)
    'auth:login': '登入',
    'auth:logout': '登出',
    'auth:failed': '登入失敗',
    'user:create': '建立使用者',
    'user:update': '更新使用者',
    'user:delete': '刪除使用者',
    'user:preferences:update': '更新偏好設定',
    'role:create': '建立角色',
    'role:update': '更新角色',
    'role:delete': '刪除角色',
    'permission:assign': '指派權限',
    'settings:update': '更新設定',
    'settings:logo:upload': '上傳標誌',
    'settings:logo:delete': '刪除標誌',
  },
  details: {
    reason: '原因',
    invalidCredentials: '認證資訊無效',
    changes: {
      single: '1 個欄位已變更',
      multiple: '{count} 個欄位已變更',
    },
    noDetails: '—',
  },
  userAgent: {
    browser: {
      chrome: 'Chrome',
      firefox: 'Firefox',
      safari: 'Safari',
      edge: 'Edge',
      unknown: '未知',
    },
    os: {
      windows: 'Windows',
      macos: 'macOS',
      linux: 'Linux',
      android: 'Android',
      ios: 'iOS',
      unknown: '未知',
    },
  },
  user: {
    system: '系統',
  },
  empty: {
    title: '找不到稽核日誌',
    subtitle: '使用者活動記錄將顯示在這裡。',
  },
  stats: {
    title: '稽核統計',
    totalActions: '總操作數',
    uniqueUsers: '不重複使用者',
    todayActions: '今日操作',
    weekActions: '本週操作',
  },
};